/*
 * Omni Studio: click and interaction events for Google Analytics, sent through window.gtag
 * (the Google & YouTube app loads the tag; its consent mode applies to these events too).
 *
 * Links are classified by DESTINATION only, never by words in the link text. The earlier version
 * matched "call", "book" and "demo" anywhere in a link and reported use-case cards such as
 * "After-hours call answering" as booking clicks.
 *
 *   omni_start_free_click     link to /pages/trial (not the #log-in anchor)    cta_intent start_free_intent
 *   omni_contact_click        link to /pages/contact, or a mailto: link        cta_intent contact_intent
 *   omni_pricing_click        link to /pages/pricing                          cta_intent pricing_intent
 *   omni_book_strategy_click  link to the booking calendar (calendar.app.google)  cta_intent booking_intent
 *   omni_usecase_task_select  a task chosen in a use-case demo window (.uc-q__b)   task_index, task_title
 *   omni_tools_list_open      the "See all ... tools" list opened (details[data-uc-wall])
 *   omni_tools_filter         a kind-of-tool filter chosen (.uc-wall__c)          tool_kind
 *   omni_tools_search         a search typed in the tools list, once per page after typing stops;
 *                             only the number of matching tools is sent, never the typed text
 *
 * Link parameters: link_url (no query string), link_text (80 characters at most), page_path, cta_intent,
 * source_section (header, footer, hero or body).
 */
(function () {
  if (window.__omniGa4CtaListenerInstalled) return;
  window.__omniGa4CtaListenerInstalled = true;

  var BOOKING_HOSTS = ['calendar.app.google', 'calendar.google.com'];

  function send(name, params) {
    if (typeof window.gtag === 'function') window.gtag('event', name, params);
  }

  /* Visible words only: screen-reader helper spans (.w-sr, for example ", waits for you") are left out. */
  function textOf(el) {
    if (!el) return '';
    var t;
    if (el.querySelector && el.querySelector('.w-sr')) {
      var copy = el.cloneNode(true);
      Array.prototype.forEach.call(copy.querySelectorAll('.w-sr'), function (n) { n.parentNode.removeChild(n); });
      t = copy.textContent;
    } else {
      t = el.innerText || el.textContent;
    }
    t = t || el.getAttribute('aria-label') || '';
    return String(t).replace(/\s+/g, ' ').trim().slice(0, 80);
  }

  function parse(href) {
    try {
      return new URL(href, window.location.href);
    } catch (error) {
      return null;
    }
  }

  function sourceSection(el) {
    if (!el || !el.closest) return 'body';
    if (el.closest('header, .w-head')) return 'header';
    if (el.closest('footer, .w-foot')) return 'footer';
    if (el.closest('[class*="hero"], [id*="hero"]')) return 'hero';
    return 'body';
  }

  function classify(url) {
    if (!url) return null;
    if (url.protocol === 'mailto:') return ['omni_contact_click', 'contact_intent'];
    if (!/^https?:$/.test(url.protocol)) return null;
    var path = url.pathname.replace(/\/+$/, '').toLowerCase();
    if (url.hostname === window.location.hostname) {
      if (path === '/pages/trial') return url.hash === '#log-in' ? null : ['omni_start_free_click', 'start_free_intent'];
      if (path === '/pages/contact') return ['omni_contact_click', 'contact_intent'];
      if (path === '/pages/pricing') return ['omni_pricing_click', 'pricing_intent'];
      return null;
    }
    for (var i = 0; i < BOOKING_HOSTS.length; i += 1) {
      if (url.hostname === BOOKING_HOSTS[i]) return ['omni_book_strategy_click', 'booking_intent'];
    }
    return null;
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var link = target.closest('a[href]');
    if (link) {
      var url = parse(link.getAttribute('href'));
      var hit = classify(url);
      if (hit) {
        send(hit[0], {
          link_url: url.protocol === 'mailto:' ? 'mailto' : url.origin + url.pathname + url.hash,
          link_text: textOf(link),
          page_path: window.location.pathname,
          cta_intent: hit[1],
          source_section: sourceSection(link)
        });
      }
      return;
    }

    var task = target.closest('.uc-q__b');
    if (task) {
      var group = task.closest('[data-uc-q]') || document;
      var tasks = Array.prototype.slice.call(group.querySelectorAll('.uc-q__b'));
      send('omni_usecase_task_select', {
        task_index: tasks.indexOf(task) + 1,
        task_title: textOf(task),
        page_path: window.location.pathname
      });
      return;
    }

    var kind = target.closest('.uc-wall__c');
    if (kind) {
      send('omni_tools_filter', { tool_kind: kind.getAttribute('data-cat') || 'All', page_path: window.location.pathname });
    }
  }, true);

  /* toggle does not bubble, but a capturing listener on document still receives it */
  document.addEventListener('toggle', function (event) {
    var el = event.target;
    if (el && el.matches && el.matches('details[data-uc-wall]') && el.open) {
      send('omni_tools_list_open', { page_path: window.location.pathname });
    }
  }, true);

  var searchTimer = null;
  var searchSent = false;
  document.addEventListener('input', function (event) {
    var box = event.target;
    if (!box || !box.classList || !box.classList.contains('uc-wall__q')) return;
    clearTimeout(searchTimer);
    searchTimer = setTimeout(function () {
      if (searchSent || !box.value.trim()) return;
      searchSent = true;
      var wall = box.closest('[data-uc-wall]');
      send('omni_tools_search', {
        search_result_count: wall ? wall.querySelectorAll('.uc-wall__t:not([hidden])').length : 0,
        page_path: window.location.pathname
      });
    }, 1200);
  }, true);

  window.__omniGa4Cta = { classify: classify };
})();
